import global from './global/index';
export default {
    global: global,
};



//////////////////
// WEBPACK FOOTER
// ./src/api/index.ts
// module id = null
// module chunks = 